import {IEntity, IEntityAttribute, IEntityAttributeProperties, IEntityHeader} from "../PA.MD.Core/PA.MD.IF.Entity";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {WB_AttributeTypeRow, WB_EntityRow} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash"
import {IDateRange} from "../PA.Core/PA.Core.IF.Basic";
import {DateUtils} from "../PA.Core/Basic/Dates";

export class CoreAttribute
    implements IEntityAttribute
{
    constructor(attrParent: IEntity,
                attrType: WB_AttributeTypeRow,
                dataRow: ESRecord,
                optionalTargetEntity: WB_EntityRow,
                idFieldName: string,
                salesAreaFieldName?: string,
                startDateFieldName?: string,
                endDateFieldName?: string)
    {
        this.attrParent = attrParent
        this.attrType = attrType
        this.dataRow = dataRow
        this.valueFieldName = idFieldName
        this.salesAreaFieldName = salesAreaFieldName || ""
        this.keyFieldName = dataRow._mapper().idAttribute
        this.targetEntity = optionalTargetEntity
        this.dateRange = {StartDt: undefined, EndDt: undefined}
        if(!_.isEmpty(startDateFieldName)) {
            let sDate = (<any> this.dataRow)[startDateFieldName]
            this.dateRange.StartDt = DateUtils.convertFromSAPBW(sDate)
        }
        if(!_.isEmpty(endDateFieldName)) {
            let sDate = (<any> this.dataRow)[endDateFieldName]
            this.dateRange.EndDt = DateUtils.convertFromSAPBW(sDate)
        }


    }

    private keyFieldName: string
    private dataRow: ESRecord
    private salesAreaFieldName: string
    private valueFieldName: string
    private attrParent: IEntity
    private attrType: WB_AttributeTypeRow
    private targetEntity: WB_EntityRow
    private dateRange: IDateRange

    get row_id(): string {
        return (<any> this.dataRow || {})[this.keyFieldName] + '-' + this.valueFieldName
    }

    get type(): WB_AttributeTypeRow {
        return this.attrType
    }

    get bReadOnly(): boolean { return true }

    get parent(): IEntity {
        return this.attrParent
    }

    get wbSalesAreaId(): number {
        if(_.isEmpty(this.salesAreaFieldName))
            return 0

        return  (<any> this.dataRow || {})[this.salesAreaFieldName]

    }


    get attribute_value(): string | number {
        return  (<any> this.dataRow || {})[this.valueFieldName]
    }

    get entity_wb_id(): number {
        return  (<any> this.dataRow || {})[this.valueFieldName]
    }

    get entity_wbEntityTypeId(): number {
        return this.targetEntity?.cif?.WB_ENTITY_ID || 0
    }

    get effectiveRange(): IDateRange {
        return this.dateRange
    }


    //-- Updates
    setBasicValue(attribute_id_ui: string | number): void {
        // Not implemented
        throw "Not implemented, change values in BO UI"
    }

    setEntity(entity: IEntityHeader): void {
        // Not implemented
        throw "Not implemented, change values in BO UI"
    }

    setProperties(props: IEntityAttributeProperties): void {
        throw "Not implemented, change values in BO UI"
    }

    //-- Remove
    async Delete(): Promise<void> {
        throw "Not implemented, change values in BO UI"
    }

    get bDeleted(): boolean {
        return ! this.dataRow.isActive
    }


}